import { render, staticRenderFns } from "./SageNumbers.vue?vue&type=template&id=50180118"
import script from "./SageNumbers.vue?vue&type=script&lang=js"
export * from "./SageNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports